import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "blanks-input-container"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  ref: "addBlankRef",
  class: "add-a-blank-dropdown-trigger"
};
const _hoisted_4 = {
  class: "add-blank-dropdown-item-container blank-as-text-item-option"
};
const _hoisted_5 = {
  class: "add-blank-dropdown-item-label"
};
const _hoisted_6 = {
  class: "add-blank-dropdown-item-description"
};
const _hoisted_7 = {
  class: "add-blank-dropdown-item-container blank-as-dropdown-item-option"
};
const _hoisted_8 = {
  class: "add-blank-dropdown-item-label"
};
const _hoisted_9 = {
  class: "add-blank-dropdown-item-description"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_blank_as_text_settings_dialog = _resolveComponent("blank-as-text-settings-dialog");
  const _component_blank_as_dropdown_settings_dialog = _resolveComponent("blank-as-dropdown-settings-dialog");
  const _component_confirm_dialog = _resolveComponent("confirm-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    ref: "editorRef",
    contenteditable: "true",
    onKeydown: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.onKeyDown && _ctx.onKeyDown(...args)),
    onKeyup: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.saveSelection && _ctx.saveSelection(...args)),
    onMouseup: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.saveSelection && _ctx.saveSelection(...args)),
    onBlur: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.onBlur && _ctx.onBlur(...args)),
    onClick: _cache[4] || (_cache[4] =
    //@ts-ignore
    (...args) => _ctx.handleEditorClick && _ctx.handleEditorClick(...args)),
    onPaste: _cache[5] || (_cache[5] =
    //@ts-ignore
    (...args) => _ctx.handlePaste && _ctx.handlePaste(...args)),
    class: "blanks-input",
    innerHTML: _ctx.formattedContent
  }, null, 40, _hoisted_2), _createVNode(_component_el_dropdown, {
    placement: "top-start",
    trigger: "click",
    "popper-class": "add-blank-dropdown"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        onClick: _ctx.addTextBlank
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.dropdownMenu.textBlank.title')), 1), _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.dropdownMenu.textBlank.description')), 1)])]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
        onClick: _ctx.addDropdownBlank
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.dropdownMenu.selectBlank.title')), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.dropdownMenu.selectBlank.description')), 1)])]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_cache[9] || (_cache[9] = _createTextVNode(" + ", -1)), _createElementVNode("u", null, _toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.addBlank.btnTitle')), 1)], 512)]),
    _: 1
  })]), _ctx.displayBlankAsTextSettingsDialog ? (_openBlock(), _createBlock(_component_blank_as_text_settings_dialog, {
    key: 0,
    visible: _ctx.displayBlankAsTextSettingsDialog,
    blank: _ctx.activeBlank,
    onBlankAsTextsSettingsUpdate: _ctx.onBlankSettingsUpdate,
    onDialogClose: _ctx.onBlankAsTextSettingsDialogClose
  }, null, 8, ["visible", "blank", "onBlankAsTextsSettingsUpdate", "onDialogClose"])) : _createCommentVNode("", true), _ctx.displayBlankAsDropdownSettingsDialog ? (_openBlock(), _createBlock(_component_blank_as_dropdown_settings_dialog, {
    key: 1,
    visible: _ctx.displayBlankAsDropdownSettingsDialog,
    blank: _ctx.activeBlank,
    onBlankAsDropdownSettingsUpdate: _ctx.onBlankSettingsUpdate,
    onDialogClose: _ctx.onBlankAsDropdownSettingsDialogClose
  }, null, 8, ["visible", "blank", "onBlankAsDropdownSettingsUpdate", "onDialogClose"])) : _createCommentVNode("", true), _createVNode(_component_confirm_dialog, {
    "v-if": _ctx.activeBlank && _ctx.displayBlankDeletionDialog,
    visible: _ctx.displayBlankDeletionDialog,
    title: _ctx.$t('chapter.question.fillInTheBlanks.deleteBlank.modal.title'),
    "confirm-button-text": _ctx.$t('chapter.question.fillInTheBlanks.deleteBlank.modal.validateBtn'),
    "cancel-button-text": _ctx.$t('chapter.question.fillInTheBlanks.deleteBlank.modal.cancelBtn'),
    "close-on-outside-click": false,
    onOnConfirmed: _cache[6] || (_cache[6] = $event => _ctx.confirmBlankDeletion()),
    onOnDialogClose: _cache[7] || (_cache[7] = $event => _ctx.cancelBlankDeletion()),
    onOnCanceled: _cache[8] || (_cache[8] = $event => _ctx.cancelBlankDeletion())
  }, {
    message: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('chapter.question.fillInTheBlanks.deleteBlank.modal.description')), 1)]),
    _: 1
  }, 8, ["v-if", "visible", "title", "confirm-button-text", "cancel-button-text"])], 64);
}